import React from "react";
import Marquee from "react-fast-marquee";
import { BadgeCheck } from "lucide-react";

const highlights = [
  "Puzzle Parking Systems",
  "Fully Automated Pit Parking",
  "Space-Saving Tower Parking",
  "Rotary Smart Parking",
  "Zero Maintenance Solutions",
  "Timely Execution Guaranteed",
  "Trusted by Top Builders",
  "Custom Parking Engineering",
  "24x7 Support & Service",
];

const MarqueeHighlights = () => {
  return (
    <div className="lt-marquee-wrapper">
      <Marquee
        gradient={false}
        speed={60}
        pauseOnHover
        className="lt-marquee"
      >
        {highlights.map((item, index) => (
          <div className="lt-marquee-item" key={index}>
            <BadgeCheck size={18} className="lt-marquee-icon" />
            <span>{item}</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeHighlights;
